module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp12_6005.3a21b9be.png";